<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>

      <h2 class="page-title">CRM</h2>
      <b-alert show variant="secondary">Bookmarklet:
        <a :href='`javascript:${b}`'>PW Lead</a>  (drag to bookmarks)
   </b-alert><p>

    </p>
<Widget title="Contact">
  <b-form @submit="onSubmit" >
<a :href="lead.url" target="_blank">{{lead.url}}</a>
<a :href="`${lead.demo}/dashboard`" target="_blank" style="float:right">[View Report]</a>
    <br>
  <table style="width:100%">
  <tr>
    <td width="30%">
      <img :src="lead.preview">
    </td>
    <td>

        <b-form-group
                id="input-group-1"
                label="Email address:"
                label-for="input-1"
        >
          <b-form-input
                  id="input-1"
                  v-model="lead.email"
                  type="email"
                  style="width:100%"
                  required
                  placeholder="Enter email"
          ></b-form-input>
        </b-form-group>
      <b-form-group
              label="Email Title:"
              label-for="input-title"
      >
        <b-form-input
                name="title"
                id="input-title"
                v-model="lead.email_title"
                type="text"
                required
                placeholder="Title"
        ></b-form-input>
      </b-form-group>
      <b-form-group
              label="Site Name:"
              label-for="input-title"
      >
        <b-form-input
                id="input-title"
                v-model="lead.website_title"
                type="text"
                required
                placeholder="Title"
        ></b-form-input>
      </b-form-group>
        <b-form-group
                label="Found Through:"
                label-for="input-via"
        >
          <b-form-input
                  id="input-via"
                  v-model="lead.found_through"
                  type="text"
                  placeholder="Found Through"
          ></b-form-input>

      </b-form-group>
    </td>
  </tr>
</table>
  </b-form>

  <table class="table table-hover" >
    <thead>
    <tr>
      <th scope="col">Issue</th>
      <th scope="col">Choose</th>

    </tr>
    </thead>
    <tbody>
    <tr >
      <td>None</td>
      <td> <b-form-radio name="x" value="A" v-on:change="setIssue({type: 'none'})">Select</b-form-radio></td>
    </tr>
    <tr v-for="spelling in lead.spelling">
      <td><b>Spelling:</b><br>{{spelling.word}} &gt; {{spelling.suggestion}}<br>
      <img v-if="spelling.preview" :src="spelling.preview" style="border:1px solid gray;border-radius:60%;height:100px">
      <div v-else>[No Preview]</div>
      </td>

      <td> <b-form-radio  name="x" value="A" v-on:change="setIssue({type: 'spelling', page:spelling.page, preview:spelling.preview, mistake: spelling.word, suggestion: spelling.suggestion})">Select</b-form-radio></td>
    </tr>

    <tr v-for="link in lead.broken_links">
      <td><b>Broken Link:</b><br>{{link.url}} ({{link.status}})<br>
       {{link.page}}
      </td>
      <td> <b-form-radio  name="x" value="A" v-on:change="setIssue({type: 'broken_link', url: link.url, page: link.page, status: link.status})">Select</b-form-radio></td>
    </tr>

    <tr v-if="lead.console_error_count">
      <td><b>{{lead.console_error_count}} Console Errors:</b>
      </td>
      <td> <b-form-radio  name="x" value="A"  v-on:change="setIssue({type: 'console_error', count: lead.console_error_count})">Select</b-form-radio></td>
    </tr>
    <tr v-if="lead.internal_redirects_count">
      <td><b>{{lead.internal_redirects_count}} Internal Redirects:</b>
      </td>
      <td> <b-form-radio  name="x" value="A"  v-on:change="setIssue({type: 'internal_redirects', count: lead.internal_redirects_count})">Select</b-form-radio></td>
    </tr>
    <tr v-if="lead.broken_resource_count">
      <td><b>{{lead.broken_resource_count}} Broken Resources:</b>
      </td>
      <td> <b-form-radio  name="x" value="A"  v-on:change="setIssue({type: 'broken_resource', count: lead.broken_resource_count})">Select</b-form-radio></td>
    </tr>
    <tr v-if="lead.layout_issues_count">
      <td><b>{{lead.layout_issues_count}} Layout Issues:</b>
      </td>
      <td> <b-form-radio  name="x" value="A"  v-on:change="setIssue({type: 'layout_issue', count: lead.layout_issues_count})">Select</b-form-radio></td>
    </tr>
    </tbody>
  </table>
  <label>Template &nbsp; </label>
  <b-form-select style="width:50%" v-model="template" :options="templateOptions"></b-form-select>
  <p></p>
  <b-button variant="primary" @click="onSubmit(false)">Send Email</b-button> &nbsp;
  <b-button variant="warning" @click="deleteLead()">Delete Lead</b-button>
  <b-button variant="info" style="float:right" @click="onSubmit(true)">Send Test Email</b-button>


</Widget>

      <Widget title="Pending"
      ><div class="table-responsive">
        <table class="table table-hover" >
          <thead>
          <tr>
            <th scope="col">Url</th>
            <th scope="col">Demo</th>

          </tr>
          <tr v-for="lead in pendingLeads">
            <td><a :href="lead.url" target="_blank">{{lead.url}}</a></td>
            <td><a :href="`${lead.demo}/dashboard`" target="_blank">Demo</a></td>
          </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
      </Widget>

    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import gql from "graphql-tag";
  import { ApolloClient } from "apollo-client";

  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget },
    apollo: {
      $subscribe: {

        subscription: {
          query() {
            return gql`subscription {
                  websites_subscription {
                    state
                    websites_plan{
                      name
                      display_name
                      options
                    }
                  }
          }`
          },
          skip () {
            return false;
          },
          result (data) {
            this.subscription = data.data.websites_subscription[0];
            this.plan = this.subscription.websites_plan;
            this.subscriptionLoading = false;

            this.loading = false;
          },

        },

      },
    },
    data() {
      return {
        websites: [],
        b: '',
        email: {},
        apiKeys: [],
        lead: {},
        pendingLeads: [],
        referrerName: '',
        form:{},
        plan: {},
        issue: {},
        templateOptions:[
                { value: 'prospect-spelling', text: 'Default'},
                { value: 'prospect-seo', text: 'Seo Agency'},
                ],
        template: 'prospect-spelling',
        toastOptions: {
          theme: 'dark',
          position: 'bottomLeft',
        },
        loading: true,
        subscriptionLoading: true,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite', user: 'user'}),
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'CRM - PageWatch.dev',
      // all titles will be injected into this template
    },
    methods: {
      bookmarklet(){
        let t = this;
        function b(owner) {
          function htmlToElement(html) {
            var template = document.createElement('template');
            html = html.trim();
            template.innerHTML = html;
            return template.content.firstChild;
          }

          function getEmails() {
            var search_in = document.body.innerHTML;
            var string_context = search_in.toString();
            var array_mails = string_context.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi) || [];
            return array_mails.filter( (email) => { return email !== owner });

          }

          var $e = htmlToElement(`<div class="pw-box" style="position:absolute;top:10px;right:10px;width:400px;z-index:999999;background-color:white">
<style>
.pw-box{
    border:1px solid gray;

}
.pw-box input{
        font-size:15px;
        font-family: "Roboto", sans-serif;
        color:black;
        padding:4px;
        margin:4px;
        border:1px solid gray;
    }
    .pw-box label{
        font-size:15px;
        font-family: "Roboto", sans-serif;
        color:black;
        padding:4px;
        margin:4px;
    }
            .pw-box p{
        font-size:15px;
        line-height:10px;
        font-family: "Roboto", sans-serif;
        color:black;
        padding:4px;
        margin:4px;
    }
        .pw-box select{
        font-size:15px;
        font-family: "Roboto", sans-serif;
        color:black;
        padding:4px;
        margin:4px;
    }
</style>
               <form method="get" action="https://api.pagewatch.dev/v1/demo" target="_blank"> <label>Url:</label><br>
               <input type="hidden" name="owner" value="` + owner+`">
               <div style="position:absolute;right:10px;top:10px;width:unset;height:unset;padding:unset;margin:unset;border:unset" onclick="document.getElementsByClassName('pw-box')[0].remove()">X</div>
               <input type="hidden" name="format" value="json">
        <input name="url" type="text" id="input_url" style="width:90%"><p>
                <label>Website Title:</label><br>
        <input name="title" type="text" id="input_title" style="width:70%"><p>
                <label>Email:</label><br>
        <input name="email" type="text" id="input_email" style="width:70%" ><p>
           <label>Found Via:</label>
           <select name="found_through" id="found_through">
  <option value=""></option>
  <option value="Product Hunt">Product Hunt</option>
  <option value="Google">Google</option>
  <option value="Hacker News">Hacker News</option>
  <option value="IndieHackers">IndieHackers</option>
  <option value="AngelList">AngelList</option>
  <option value="Reddit">Reddit</option>
  <option value="BetaList">Betalist</option>
  <option value="backlinko">backlinko</option>
</select><p></p>
           <input type="submit" value="Submit" style="border:1px solid gray;font-size:15px" ><p>
           </form>
                </div>`);

          document.body.append($e);
          document.getElementById("input_url").value = document.location.origin + document.location.pathname
          let arr = document.title.split('-');
          let s = arr[arr.length - 1].trim()
          document.getElementById("input_title").value = s;
          let emails = getEmails();
          if (emails.length > 0) {
            document.getElementById("input_email").value = emails[0];
            if (emails.length > 1) {

            }
          }
        }

        t.b = (`f__ = ${b}`) + ';f__("'+t.user.email+'")';
      },
      deleteLead(){
        let data = {
          option: 'delete',
          leadId: this.lead.id,
        }
        axios
                .put(`crm/leads`, data)
                .then(
                        response => {
                          this.loading = true;
                          return this.getLeads();
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );
      },
      onSubmit(test){
        let data = {
          leadId: this.lead.id,
          template: this.template,
          email: this.lead.email,
          emailTitle: this.lead.email_title,
          referrerName: this.lead.referrer_name,
          referrerFullName: this.lead.referrer_full_name,
          reportUrl: this.lead.demo,
          reportPreviewImage: this.lead.preview,
          websiteTitle: this.lead.website_title,
          via: this.lead.found_through,
        };
        if (this.issue.type === 'spelling'){
          data.issueSpelling = true;
          data.spellingMistake = this.issue.mistake;
          data.spellingSuggestion = this.issue.suggestion;
          data.spellingPreviewImage = this.issue.preview;
          data.spellingPage = this.issue.page;
        }
        if (this.issue.type === 'broken_link'){
          data.issueBrokenLink = true;
          data.brokenLinkPage = this.issue.page;
          data.brokenLinkUrl = this.issue.url;
          if (this.issue.status){
            data.brokenLinkStatus = this.issue.status;
          }

        }
        if (this.issue.type === 'console_error'){
          data.issueConsoleError = true;
          data.consoleErrorCount = this.issue.count;
        }
        if (this.issue.type === 'internal_redirects'){
          data.issueInternalRedirects = true;
          data.internalRedirectsCount = this.issue.count;
        }
        if (this.issue.type === 'broken_resource'){
          data.issueBrokenResource = true;
          data.brokenResourceCount = this.issue.count;
        }
        if (this.issue.type === 'layout_issue'){
          data.issueLayoutError = true;
          data.layoutIssuesCount = this.issue.count;
        }
        this.sendEmail(data, test);
      },
      setIssue(issue){
        this.issue = issue;
      },
      sendEmail(data, test=true){
        if (test){
          data.test = true;
        }
        axios
                .post(`crm/leads`, data)
                .then(
                        response => {
                          if (!test) {
                            this.loading = true;
                            return this.getLeads();
                          }
                          else{
                            this.loading = false;
                            return true;
                          }
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );
      },
      getLeads(){
        axios
                .get(`crm/leads`)
                .then(
                        response => {
                          this.issue = {}
                          this.loading = false;
                          this.pendingLeads = response.data.pending_leads;
                          this.referrerName = response.data.referrerName;
                          this.lead = response.data.lead;
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );

      },
    },
    created() {
      this.$watch("$route",() => {
        this.currentPage = this.$route.query.page || 1;
        }, {
        immediate: true
      });
    },
    mounted(){
      this.getLeads();
      this.bookmarklet();
    }
  };
</script>

<style src="./Crm.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
